var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _line, _g, _rect, _path32, _path33, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDuoLanding(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 509,
    height: 521,
    viewBox: "0 0 509 521",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M217.173 0H305.4L509 521H0L217.173 0Z",
    fill: "url(#paint0_linear_1_2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M395.541 162.521L391.27 161.093C390.337 160.78 389.834 159.771 390.146 158.839C390.317 158.329 390.708 157.924 391.211 157.736L395.43 156.159L396.859 151.887C397.171 150.955 398.18 150.452 399.113 150.764C399.622 150.934 400.028 151.326 400.216 151.829L401.793 156.048L406.064 157.476C406.997 157.788 407.5 158.798 407.188 159.73C407.017 160.24 406.626 160.645 406.123 160.833L401.904 162.41L400.475 166.682C400.163 167.614 399.154 168.117 398.221 167.805C397.712 167.635 397.307 167.243 397.118 166.74L395.541 162.521Z",
    fill: "#8B4FFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M421.138 189.601L415.023 187.556C413.688 187.109 412.967 185.665 413.414 184.329C413.658 183.6 414.218 183.02 414.939 182.75L420.979 180.492L423.024 174.378C423.471 173.042 424.915 172.322 426.251 172.769C426.98 173.013 427.56 173.573 427.83 174.294L430.088 180.333L436.202 182.379C437.538 182.826 438.258 184.27 437.811 185.606C437.567 186.335 437.007 186.915 436.286 187.185L430.247 189.442L428.201 195.557C427.754 196.892 426.31 197.613 424.974 197.166C424.245 196.922 423.665 196.362 423.395 195.641L421.138 189.601Z",
    fill: "#AE84FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.5796 284.41L47.0068 282.211C45.5715 281.731 44.7972 280.178 45.2774 278.743C45.5397 277.959 46.1421 277.335 46.9166 277.045L53.4087 274.618L55.6075 268.045C56.0877 266.61 57.6405 265.836 59.0757 266.316C59.8599 266.578 60.4837 267.181 60.7732 267.955L63.2001 274.447L69.7729 276.646C71.2082 277.126 71.9825 278.679 71.5023 280.114C71.24 280.899 70.6376 281.522 69.8631 281.812L63.371 284.239L61.1721 290.812C60.692 292.247 59.1392 293.021 57.7039 292.541C56.9198 292.279 56.296 291.676 56.0065 290.902L53.5796 284.41Z",
    fill: "#8B4FFC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M237.529 302.755L110.06 268.521C103.227 266.686 96.623 272.034 97.0169 279.083C98.9092 312.95 122.706 342.378 156.383 351.423C190.06 360.467 225.241 346.879 243.62 318.456C247.446 312.54 244.361 304.59 237.529 302.755Z",
    fill: "#58CC02"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M151.968 255.299C145.367 235.723 161.769 215.892 182.373 217.391C201.587 218.788 221.785 219.188 231.332 215.968C240.879 212.749 256.71 200.198 271.154 187.451C286.643 173.781 311.705 179.629 318.307 199.205L336.352 252.716C337.524 256.19 338.466 259.687 339.186 263.19C339.218 263.276 339.249 263.362 339.28 263.448C345.57 293.62 337.831 324.77 331.533 343.273C315.428 387.534 266.573 410.531 222.162 394.656C182.131 380.347 159.327 339.322 166.646 298.822L151.968 255.299Z",
    fill: "#58CC02"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M234.699 344.948L256.431 340.978C257.595 340.766 258.618 341.694 258.449 342.811C257.64 348.18 253.248 352.588 247.506 353.636C241.765 354.685 236.103 352.114 233.456 347.376C232.905 346.39 233.535 345.161 234.699 344.948Z",
    fill: "#8EE000"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M218.911 238.41C231.175 244.614 247.279 239.183 254.32 226.469C261.361 213.754 271.025 281.053 270.97 280.891C270.944 280.813 265.499 282.624 254.637 286.324C251.725 287.316 246.481 289.109 238.904 291.704C217.4 252.038 210.736 234.273 218.911 238.41Z",
    fill: "#89E219"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M267.889 195.256L252.498 231.002C251.673 232.917 252.951 235.084 255.022 235.279C264.974 236.22 274.562 230.563 278.628 221.119C282.694 211.675 280.228 200.793 272.724 194.168C271.162 192.789 268.714 193.34 267.889 195.256Z",
    fill: "#8EE000"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M284.447 196.959L269.056 232.704C268.231 234.62 269.51 236.786 271.581 236.982C281.533 237.922 291.12 232.265 295.187 222.821C299.253 213.378 296.786 202.496 289.282 195.871C287.721 194.492 285.272 195.043 284.447 196.959Z",
    fill: "#8EE000"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M189.546 221.59L222.485 240.388C224.25 241.395 224.516 243.823 223.01 245.182C215.773 251.711 204.964 252.903 196.262 247.936C187.559 242.97 183.128 233.081 185.127 223.562C185.543 221.581 187.78 220.583 189.546 221.59Z",
    fill: "#89E219"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M177.168 233.164L208.154 250.848C209.815 251.796 210.065 254.079 208.648 255.358C201.84 261.5 191.672 262.621 183.486 257.949C175.299 253.277 171.13 243.974 173.01 235.02C173.402 233.156 175.507 232.217 177.168 233.164Z",
    fill: "#89E219"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M169.914 281.305C163.7 262.878 173.601 242.903 192.027 236.689C210.454 230.475 230.429 240.375 236.643 258.802L242.187 275.242C248.401 293.669 238.501 313.644 220.074 319.858C201.648 326.072 181.673 316.172 175.458 297.745L169.914 281.305Z",
    fill: "#89E219"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M252.602 253.42C246.388 234.993 256.288 215.018 274.715 208.804C293.141 202.59 313.117 212.49 319.331 230.917L324.875 247.357C331.089 265.784 321.189 285.759 302.762 291.973C284.335 298.187 264.36 288.287 258.146 269.86L252.602 253.42Z",
    fill: "#89E219"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M181.523 279C177.201 266.181 184.088 252.286 196.906 247.963C209.725 243.64 223.621 250.527 227.943 263.346L232.346 276.401C236.669 289.22 229.782 303.116 216.963 307.438C204.145 311.761 190.249 304.874 185.926 292.055L181.523 279Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M262.275 251.771C257.952 238.952 264.84 225.057 277.658 220.734C290.477 216.411 304.372 223.298 308.695 236.117L313.098 249.172C317.421 261.991 310.534 275.887 297.715 280.209C284.897 284.532 271.001 277.645 266.678 264.826L262.275 251.771Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M201.109 273.206C199.083 267.197 202.311 260.683 208.32 258.657C214.328 256.631 220.842 259.859 222.868 265.868L226.782 277.473C228.808 283.481 225.58 289.995 219.571 292.021C213.563 294.048 207.049 290.819 205.023 284.811L201.109 273.206Z",
    fill: "#4B4B4B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M268.736 253.36C273.543 251.739 276.126 246.528 274.505 241.721C273.975 240.149 273.061 238.815 271.903 237.788C272.837 237.1 273.892 236.543 275.05 236.152C281.059 234.126 287.573 237.354 289.599 243.363L293.512 254.968C295.539 260.976 292.31 267.49 286.302 269.516C280.293 271.543 273.779 268.314 271.753 262.306L268.736 253.36C268.736 253.36 268.736 253.36 268.736 253.36Z",
    fill: "#4B4B4B"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M207.774 264.226C209.395 269.033 206.813 274.244 202.006 275.865C197.199 277.486 191.988 274.903 190.367 270.096C188.746 265.289 191.329 260.078 196.135 258.457C200.942 256.836 206.153 259.419 207.774 264.226Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M242.798 288.227C240.682 281.952 244.054 275.148 250.329 273.032C256.605 270.916 263.408 274.288 265.525 280.563L273.267 303.522C275.383 309.798 272.012 316.601 265.736 318.717C259.46 320.834 252.657 317.462 250.541 311.186L242.798 288.227Z",
    fill: "#F49000"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M245.082 288.298C243.329 283.101 246.121 277.468 251.318 275.715C256.515 273.963 262.148 276.755 263.9 281.951L270.03 300.127C271.782 305.324 268.99 310.957 263.794 312.709C258.597 314.462 252.964 311.67 251.211 306.473L245.082 288.298Z",
    fill: "#B06800"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250.537 280.815C250.529 280.821 250.526 280.824 250.526 280.824C249.479 281.767 247.866 281.682 246.923 280.635C245.98 279.588 246.065 277.975 247.112 277.032C247.906 276.316 249.182 275.637 250.469 275.151C251.798 274.648 253.474 274.224 255.155 274.257C256.564 274.284 257.684 275.449 257.656 276.858C257.629 278.267 256.464 279.386 255.055 279.359C254.236 279.343 253.23 279.563 252.273 279.924C251.809 280.1 251.398 280.293 251.073 280.472C250.911 280.561 250.781 280.642 250.682 280.709C250.633 280.742 250.595 280.77 250.567 280.791C250.554 280.801 250.544 280.809 250.537 280.815Z",
    fill: "#FFDE00"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M270.935 280.097C271.243 280.575 271.062 281.206 270.563 281.479L256.062 289.41L239.719 291.88C239.157 291.965 238.63 291.573 238.586 291.006C237.975 283.159 242.719 275.599 250.517 272.969C258.316 270.339 266.669 273.482 270.935 280.097Z",
    fill: "#FFC200"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250.402 280.544C250.395 280.55 250.392 280.552 250.392 280.552C249.344 281.495 247.731 281.411 246.788 280.364C245.845 279.316 245.93 277.703 246.977 276.76C247.772 276.045 249.047 275.366 250.334 274.879C251.664 274.377 253.339 273.953 255.02 273.985C256.429 274.013 257.549 275.177 257.521 276.586C257.494 277.995 256.329 279.115 254.921 279.087C254.101 279.071 253.095 279.291 252.138 279.653C251.674 279.828 251.263 280.021 250.938 280.201C250.777 280.29 250.646 280.371 250.547 280.438C250.498 280.471 250.46 280.498 250.433 280.519C250.419 280.53 250.409 280.538 250.402 280.544Z",
    fill: "#FFDE00"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M203.236 344.163C208.37 340.566 215.447 341.813 219.044 346.947L229.154 361.38C232.75 366.514 231.504 373.591 226.37 377.188C221.235 380.784 214.158 379.538 210.561 374.404L200.451 359.971C196.855 354.837 198.101 347.759 203.236 344.163Z",
    fill: "#F49000"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M241.602 444.873C241.602 439.518 245.942 435.177 251.297 435.177H258.952C264.306 435.177 268.647 439.518 268.647 444.873C268.647 450.228 264.306 454.569 258.952 454.569H251.297C245.942 454.569 241.602 450.228 241.602 444.873Z",
    fill: "#F49000"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M257.54 419.79C263.597 421.985 266.727 428.676 264.532 434.733L260.23 446.6C258.035 452.658 251.345 455.788 245.287 453.593C239.23 451.397 236.1 444.707 238.295 438.65L242.597 426.782C244.792 420.725 251.482 417.594 257.54 419.79Z",
    fill: "#F49000"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M269.858 299.618L270.03 300.127C271.782 305.324 268.99 310.957 263.793 312.709C258.597 314.462 252.964 311.67 251.211 306.473L250.914 305.592C252.481 301.671 256.019 298.601 260.543 297.777C263.916 297.162 267.216 297.907 269.858 299.618Z",
    fill: "#FFB8D1"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M185.867 298.692L230.277 302.055C229.545 311.721 221.116 318.964 211.45 318.232L202.044 317.519C192.378 316.787 185.135 308.358 185.867 298.692Z",
    fill: "#89E219"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M317.429 256.469L281.842 283.248C286.797 289.833 296.153 291.155 302.739 286.199L314.478 277.366C321.063 272.411 322.385 263.055 317.429 256.469Z",
    fill: "#89E219"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M322.915 360.613C307.459 372.419 286.68 377.642 268.917 378.692L268.86 378.696L268.804 378.701C265.675 379.002 263.486 378.522 261.978 377.776C260.483 377.036 259.481 375.949 258.838 374.723C258.181 373.468 257.891 372.045 257.907 370.724C257.925 369.361 258.263 368.356 258.581 367.861L258.659 367.74L265.829 354.276C266.606 352.774 266.018 350.927 264.516 350.15C263.014 349.373 261.167 349.961 260.39 351.463L253.344 364.686C252.306 366.373 251.812 368.524 251.784 370.646C251.756 372.866 252.234 375.312 253.415 377.566C254.611 379.847 256.519 381.907 259.261 383.264C261.978 384.609 265.336 385.178 269.333 384.802C282.638 384.009 297.936 380.954 311.74 374.45C315.893 370.285 319.647 365.659 322.915 360.613Z",
    fill: "#3DBE01"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 245.34,
    y1: 391.926,
    x2: 344.209,
    y2: 250.025,
    stroke: "#442A75",
    strokeWidth: 9.26411,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 337.113,
    y: 230.667,
    width: 21.0718,
    height: 21.0718,
    transform: "rotate(34.8061 337.113 230.667)",
    fill: "#372558"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.322,
    y: 278.776,
    width: 21.0718,
    height: 21.0718,
    transform: "rotate(34.8061 406.322 278.776)",
    fill: "#372558"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.715,
    y: 254.724,
    width: 21.0718,
    height: 21.0718,
    transform: "rotate(34.8061 371.715 254.724)",
    fill: "#372558"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.414,
    y: 242.693,
    width: 21.0718,
    height: 21.0718,
    transform: "rotate(34.8061 354.414 242.693)",
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.018,
    y: 266.75,
    width: 21.0718,
    height: 21.0718,
    transform: "rotate(34.8061 389.018 266.75)",
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21.0718,
    height: 21.0718,
    transform: "matrix(-0.821088 -0.570801 -0.570801 0.821088 394.285 296.084)",
    fill: "#372558"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21.0718,
    height: 21.0718,
    transform: "matrix(-0.821088 -0.570801 -0.570801 0.821088 359.684 272.026)",
    fill: "#372558"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21.0718,
    height: 21.0718,
    transform: "matrix(-0.821088 -0.570801 -0.570801 0.821088 376.986 284.054)",
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21.0718,
    height: 21.0718,
    transform: "matrix(-0.821088 -0.570801 -0.570801 0.821088 411.59 308.11)",
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21.0718,
    height: 21.0718,
    transform: "matrix(-0.821088 -0.570801 -0.570801 0.821088 342.383 260)",
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.053,
    y: 265.272,
    width: 21.0718,
    height: 21.0718,
    transform: "rotate(34.8061 313.053 265.272)",
    fill: "#372558"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.258,
    y: 313.382,
    width: 21.0718,
    height: 21.0718,
    transform: "rotate(34.8061 382.258 313.382)",
    fill: "#372558"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.654,
    y: 289.33,
    width: 21.0718,
    height: 21.0718,
    transform: "rotate(34.8061 347.654 289.33)",
    fill: "#372558"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.352,
    y: 277.298,
    width: 21.0718,
    height: 21.0718,
    transform: "rotate(34.8061 330.352 277.298)",
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.959,
    y: 301.356,
    width: 21.0718,
    height: 21.0718,
    transform: "rotate(34.8061 364.959 301.356)",
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21.0718,
    height: 21.0718,
    transform: "matrix(-0.821088 -0.570801 -0.570801 0.821088 370.229 330.689)",
    fill: "#372558"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21.0718,
    height: 21.0718,
    transform: "matrix(-0.821088 -0.570801 -0.570801 0.821088 335.623 306.631)",
    fill: "#372558"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21.0718,
    height: 21.0718,
    transform: "matrix(-0.821088 -0.570801 -0.570801 0.821088 352.926 318.657)",
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21.0718,
    height: 21.0718,
    transform: "matrix(-0.821088 -0.570801 -0.570801 0.821088 387.531 342.714)",
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 21.0718,
    height: 21.0718,
    transform: "matrix(-0.821088 -0.570801 -0.570801 0.821088 318.324 294.605)",
    fill: "#EDEDED"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 249,
    y: 346.667,
    width: 34.6667,
    height: 32,
    rx: 16,
    fill: "#58CC02"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.847 246.94C119.718 250.649 126.195 250.981 130.789 247.881C131.73 247.217 131.73 245.833 130.733 245.058L112.301 231.054C111.914 230.777 111.526 230.667 111.139 230.667C110.419 230.667 109.81 231.054 109.589 231.774C107.873 237.088 109.976 243.232 114.847 246.94Z",
    fill: "#58CC02"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M332.181 401.607C337.052 405.316 343.529 405.648 348.123 402.548C349.064 401.884 349.064 400.5 348.068 399.725L329.635 385.721C329.248 385.444 328.86 385.333 328.473 385.333C327.753 385.333 327.144 385.721 326.923 386.441C325.207 391.754 327.31 397.898 332.181 401.607Z",
    fill: "#58CC02"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 183.666,
    y: 454.667,
    width: 117.333,
    height: 13.3333,
    rx: 6.66667,
    fill: "#AFAFAF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_2",
    x1: 254.5,
    y1: 521,
    x2: 254.5,
    y2: 58.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B994FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#702BF0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 337.107,
    y: 230.667,
    width: 105.359,
    height: 84.2884,
    rx: 12.6431,
    transform: "rotate(34.8061 337.107 230.667)",
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuoLanding);
export default __webpack_public_path__ + "static/media/duo-landing.6a714ad31b435b39fab7e66b68ac9ed0.svg";
export { ForwardRef as ReactComponent };